import axios from "axios";
import { nanoid } from "nanoid";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { PuffLoader } from "react-spinners";
import { toast } from "react-toastify";
import { api } from "../../../config/api";
import UNIVERSAL from "../../../config/config";
import { generateImageFromCreative } from "../../../libs/canvas";
import { generateCreativeID } from "../../../libs/utils";
import { stepsActions } from "../../../store/steps-slice";
import Brand from "../../Brand/Brand";
import LinkFbPage from "../../Home/LinkFbPage/LinkFbPage";
import CampaignStep1 from "../CampaignSteps/CampaignStep1/CampaignStep1";
import CampaignStep2 from "../CampaignSteps/CampaignStep2/CampaignStep2";
import CampaignStep3 from "../CampaignSteps/CampaignStep3/CampaignStep3";
import CampaignStep4 from "../CampaignSteps/CampaignStep4/CampaignStep4";
import Step4BillContainer from "../CampaignSteps/CampaignStep4/Step4BillContainer/Step4BillContainer";
import CampaignConnectWhatsApp from "../ConnectWhatsApp/CampaignConnectWhatsApp";
import StepsContainer from "../StepsContainer/StepsContainer";
import StepsHeadingSection from "../StepsHeadingSection/StepsHeadingSection";
import "./CreateCampaign.css";
import { fetchAllCampaignDetails } from "../../../store/campaigns-slice";
import CampaignCreatedModal from "./CampaignCreatedModal/CampaignCreatedModal";
import { Modal } from "@mui/material";

const CreateCampaign = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { search } = useLocation();

  const query = React.useMemo(() => new URLSearchParams(search), [search]);
  const product_id = Number(query.get("selectedProduct"));

  const stepNo = useSelector((state) => state.steps.stepNumber);
  const [stepNumber, setStepNumber] = useState(stepNo);
  const [products, setProduct] = useState();
  const [step2Spinner, setStep2Spiner] = useState(false);
  const [pricingData, setPricingData] = useState();
  const [step4Spinner, setStep4Spiner] = useState(false);
  const [templates, setTemplates] = useState();
  const [creatives, setCreatives] = useState();
  const [userData, setUserData] = useState();
  const [step3Spinner, setStep3Spinner] = useState(false);
  const [isStep, setIsStep] = useState("continue");
  const [showBrandModal, setShowBrandModal] = useState(false);
  const [brandData, setBrandData] = useState();
  const [isBrandData, setIsBrandData] = useState(true);
  const [orderId, setOrderId] = useState("");
  const [isWhatsAppLinked, setIsWhatsAppLinked] = useState("");
  const [useWallet, setUseWallet] = useState(false);
  const [isSavingAdcopies, setIsSavingAdcopies] = useState(false);
  const [isWhatsappLoading, setWhatsappLoading] = useState(true);
  const [campaignCreatedModal, setCampaignCreatedModal] = useState(false);

  const { data: homePageProfile, loading: homePageProfileLoading } = useSelector((state) => state.homePageProfile);

  const step2Data = useSelector((state) => state.steps.step2Data);
  const step3Data = useSelector((state) => state.steps.step3Data);
  const step4Data = useSelector((state) => state.steps.step4Data);

  const user = useSelector((state) => state.user.user);

  const coords = useSelector((state) => state.steps.coords);
  const location = useSelector((state) => state.steps.location);

  const searchLocationInput = useSelector((state) => state.steps.searchLocationInput);

  const campaignOrderId = useSelector((state) => state.steps.campaignOrderId);

  // useEffect(() => {
  //   return () => {
  //     dispatch(stepsActions.resetSteps());
  //   };
  // }, []);

  useEffect(() => {
    if (user?.app_business_id) {
      dispatch(
        fetchAllCampaignDetails({
          businessId: user?.app_business_id,
          status: ["ALL"],
          request_page: ["homepage", "myads"],
        })
      );
    }
  }, [user?.app_business_id]);

  function handleBackStep() {
    setIsStep("back");
    setStepNumber((state) => state - 1);
    if (stepNumber === 3) setCreatives(undefined);
  }

  async function handleContinue() {
    if (stepNumber < 4) {
      setIsStep("continue");
    }

    if (stepNumber === 1) {
      if (location) {
        async function updateUserLocation() {
          return fetch(UNIVERSAL.BASEURL_1 + "/biz/updateBiz", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
            },
            body: JSON.stringify({
              businessId: user?.app_business_id,
              businessName: user?.business_name,
              businessCategory: user?.business_category,
              locationDetails: {
                latitude: coords.lat,
                longitude: coords.lng,
                state: location.state,
                city: location.city,
                locality: location.locality,
                country: location.country,
                location_id: location.id,
              },
            }),
          })
            .then((response) => response.json())
            .catch((error) => {
              console.log(error);
            });
        }
        updateUserLocation();
        setStepNumber((state) => state + 1);
      }
    }

    if (stepNumber === 2) {
      await axios
        .post(
          UNIVERSAL.BASEURL_1 + "/campaigns/campaign_progress",
          {
            business_id: user.app_business_id,
            campaign_order_id: null,
            stage: "package_selected",
            campaign_order: {
              plan_id: 10,
              product_id: step2Data.product_id,
              campaign_objective: "BUSINESS_REACH",
              latitude: coords?.lat,
              longitude: coords?.lng,
            },
          },
          {
            headers: {
              "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
            },
          }
        )
        .then((response) => {
          dispatch(stepsActions.setCampaignOrderId(response.data.data.campaign_order_id));
        });
      setStepNumber((state) => state + 1);
    }

    if (stepNumber === 3) {
      async function updateSelectedCard() {
        const ad_templates = [];
        for (const creative of creatives.selected) {
          const template = templates?.find((template) => template.id === creative.template);
          const base64 = await generateImageFromCreative({ creative, template, type: "base64" });
          const adImage = await fetch(`${UNIVERSAL.BASEURL_1}/internal/upload_image`, {
            method: "POST",
            headers: { "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe" },
            body: JSON.stringify({
              filename: nanoid() + ".png",
              image: base64.substring(22),
            }),
          })
            .then((response) => response.json())
            .then((response) => response.url);
          ad_templates.push({ adCaption: creative.headline, adImage, cta: { ctaText: creative.caption, ctaBtn: creative.cta } });
        }
        await fetch(UNIVERSAL.BASEURL_1 + "/campaigns/campaign_progress", {
          method: "POST",
          headers: { "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe" },
          body: JSON.stringify({
            business_id: user.app_business_id,
            campaign_order_id: campaignOrderId,
            stage: "ad_templates",
            campaign_order: {
              plan_id: 10,
              product_id: step2Data?.product_id,
              campaign_objective: "BUSINESS_REACH",
              latitude: coords?.lat,
              longitude: coords?.lng,
              ad_templates,
            },
          }),
        })
          .then((res) => res.json())
          .then((res) => {
            setOrderId(res?.data?.campaign_order_id);
            setStepNumber((state) => state + 1);
          })
          .finally(() => {
            setIsSavingAdcopies(false);
          });
      }
      setIsSavingAdcopies(true);
      updateSelectedCard();
    }

    if (stepNumber === 4) {
      const response = await axios.post(UNIVERSAL.BASEURL_2 + "/payments/api/v1/create_campaign_payment", {
        campaign_order_id: Number(orderId),
        is_wallet_deducted: useWallet,
        payment_meta: {
          plan_id: step4Data.id,
          unit: step4Data?.campaign_duration,
          unit_type: step4Data?.campaign_duration_unit,
        },
      });
      const data = response.data.data;
      if (data.payment_modes.includes("INSTAMOJO")) {
        const script = document.createElement("script");
        script.src = "https://js.instamojo.com/v1/checkout.js";
        script.onerror = () => {
          alert("Instamojo SDK failed to load. Are you online?");
        };
        script.onload = async () => {
          try {
            window.Instamojo.open(data.payment_long_url);
          } catch (err) {
            alert(err);
          }
        };
        document.body.appendChild(script);
      } else {
        if (data.payment_modes.length === 1 && data.payment_modes[0] === "WALLET" && data.is_campaign_created) {
          // toast("Campaign created successfully", { type: "success" });
          setCampaignCreatedModal(true);

          setTimeout(() => {
            setCampaignCreatedModal(false);
            navigate("/campaign");
            dispatch(stepsActions.resetSteps());
          }, 3000);
        } else {
          toast("Something went wrong! Please try again", { type: "error" });
        }
      }
    }
  }

  useEffect(() => {
    if (stepNumber === 2) {
      async function getProductsData() {
        setStep2Spiner(true);
        return fetch(UNIVERSAL.BASEURL_1 + "/product/listProduct", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
          },
          body: JSON.stringify({
            businessId: user?.app_business_id,
          }),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            if (responseJson.data.length > 0) {
              setProduct(responseJson.data);
              setStep2Spiner(false);
            } else {
              navigate("/products/add-new-product");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      getProductsData();
    }
  }, [stepNumber]);

  useEffect(() => {
    if (!pricingData || !pricingData.length) return;
    dispatch(
      stepsActions.step4({
        ...pricingData[1],
        img2: "https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/growth.svg",
      })
    );
  }, [pricingData]);

  useEffect(() => {
    if (stepNumber === 4) {
      async function getProductsData() {
        setStep4Spiner(true);
        return fetch(UNIVERSAL.BASEURL_1 + "/bizv2/homepage", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
          },
          body: JSON.stringify({
            businessId: user?.app_business_id,
            version: 5,
          }),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            if (responseJson.data) {
              console.log(responseJson);
              let data = [];
              for (let i = 0; i < responseJson.campaign_plans.interakt.length; i++) {
                data.push({
                  id: responseJson.campaign_plans.interakt[i].id,
                  plan_name: responseJson.campaign_plans.interakt[i].plan_name,
                  campaign_budget: responseJson.campaign_plans.interakt[i].campaign_budget,
                  campaign_target: responseJson.campaign_plans.interakt[i].campaign_target,
                  campaign_duration: responseJson.campaign_plans.interakt[i].campaign_duration,
                  campaign_duration_unit: responseJson.campaign_plans.interakt[i].campaign_duration_unit,
                });
              }
              setPricingData(data);
              setStep4Spiner(false);
            } else {
              setStep4Spiner(false);
            }
          })
          .catch((error) => {
            console.log(error);
            setStep4Spiner(false);
          });
      }
      getProductsData();
    }
  }, [stepNumber]);

  useEffect(() => {
    if (stepNumber === 3) {
      (async () => {
        await fetch("https://uat.zocket.com/customer/ads/api/v1/instamojo/templates", {
          method: "GET",
          headers: {
            Authorization:
              "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2OTI2OTE3MDA4OTYsImlhdCI6MTY5MjYwNTMwMCwibmJmIjoxNjkyNjA1MzAwLCJzdWIiOjE1OH0.BFJswLii8pRqJ8GAs9IjQKmgATOIq3mKpPs5IJsFy74gOvAiQlztGD_PZ6nCfNQYxzvT0TbVyfULJLWcnxlw9DvkrTwfr3ayIV8HS8BoAPbkj6wNnY4WsK-7XNoZxmBzkoX9834NbAwk0Qe4-4C9zY41btyGUhlEN3Vtpkxftbg",
          },
        })
          .then((response) => response.json())
          .then((responseJson) => {
            if (responseJson.data) {
              setTemplates(responseJson.data);
            }
          });
      })();
    }
  }, [stepNumber]);

  const fetchHeadlines = useMutation({
    mutationFn: async (data) => {
      const response = await api.post("/ads/api/v1/ad-headlines", data);
      return response.data.data;
    },
  });

  const fetchCaptions = useMutation({
    mutationFn: async (data) => {
      const response = await api.post("/ads/api/v1/ad-contents", data);
      return response.data.data;
    },
  });

  const fetchColors = useMutation({
    mutationFn: async (brand) => {
      const response = await fetch(UNIVERSAL.BASEURL_2 + "/user/api/v1/business/brand_color_suggestion", {
        method: "POST",
        body: JSON.stringify({
          brand_logo: brand,
          business_user_id: user?.app_business_id,
        }),
      }).then((response) => response.json());
      return response.data;
    },
  });

  const scoreImage = useMutation({
    mutationFn: async (images) => {
      const response = await api.post("/ads/api/v1/score-images-sync", { images });
      return response.data.data;
    },
  });

  const handleGenerateCreatives = async (profileUrl) => {
    if (!step2Data || !templates || !templates.length) return;
    const images = step2Data?.media?.slice(0, 3).map((media) => media.url);
    const scores = [];
    const creatives = [];
    const [captions, headlines, colors] = await Promise.all([
      fetchCaptions.mutateAsync({ name: step2Data.name, description: step2Data.description, selling_price: step2Data.selling_price, currency: step2Data.currency, limit: 1 }),
      fetchHeadlines.mutateAsync({ name: step2Data.name, description: step2Data.description, selling_price: step2Data.selling_price, currency: step2Data.currency, limit: 1 }),
      fetchColors.mutateAsync(images[0]),
    ]);
    const caption = captions.at(0) ?? "Contact us now for the best deals!";
    const headline = headlines.at(0) ?? "Contact us now for the best deals!";
    const background = brandData?.primary_colors ? JSON.parse(brandData?.primary_colors).at(0) : colors.primary_color_list.at(0) ?? "#0065FF";
    const cta = "Contact Now";
    for (const image of images) {
      const imageID = nanoid();
      scores.push({ image_id: imageID, image_url: image, logo_url: profileUrl });
      for (const template of templates) {
        const creativeID = generateCreativeID(template.name, imageID);
        creatives.push({ id: creativeID, template: template.id, image: image, score: -1, background, caption, cta, headline, logo: profileUrl });
      }
    }
    setCreatives((state) => ({ ...state, all: creatives }));
    const scoreData = await scoreImage.mutateAsync(scores);
    for (const payload of scoreData) {
      if (!payload) continue;
      payload.complete_temp_orientation_data.forEach((data, index) => {
        const score = data.template_score;
        const id = generateCreativeID(data.temp_id, payload.image_id);
        setCreatives((state) => ({
          ...state,
          all: (state?.all ?? []).map((creative) => (creative.id === id ? { ...creative, score, orientation: payload.temp_orientation, resize: data.image_data } : creative)),
        }));
      });
    }
    setCreatives((state) => ({ ...state, selected: (state?.all ?? []).sort((a, b) => b.score - a.score).slice(0, 3) }));
  };

  useEffect(() => {
    async function getUserProfile() {
      setWhatsappLoading(true);
      return fetch(UNIVERSAL.BASEURL_1 + "/biz/getBiz", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
        },
        body: JSON.stringify({
          businessId: user?.app_business_id,
        }),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson) {
            setIsWhatsAppLinked(responseJson?.data?.has_whatsapp_business_number === 1);
            setUserData(responseJson.data);
          }
        })
        .finally(() => {
          setWhatsappLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    getUserProfile();
  }, []);

  useEffect(() => {
    if (!step2Data || stepNumber !== 3 || !templates || !templates.length || creatives?.selected?.length > 0) return;
    async function getUserProfile() {
      setStep3Spinner(true);
      return fetch(UNIVERSAL.BASEURL_1 + "/biz/getBiz", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
        },
        body: JSON.stringify({
          businessId: user?.app_business_id,
        }),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson) {
            setUserData(responseJson.data);
            handleGenerateCreatives(brandData?.brand_logo ?? responseJson.data.profileUrl).finally(() => {
              setStep3Spinner(false);
            });
          }
        })
        .finally(() => {})
        .catch((error) => {
          console.log(error);
        });
    }
    getUserProfile();
  }, [stepNumber, templates, step2Data]);

  useEffect(() => {
    async function getBrandData() {
      return fetch(UNIVERSAL.BASEURL_2 + "/user/api/v1/business/info", {
        method: "POST",
        body: JSON.stringify({
          business_id: user?.app_business_id,
        }),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson?.data?.brand_name === null || responseJson?.data?.brand_name?.length === 0) {
            setShowBrandModal(true);
            setIsBrandData(false);
          } else {
            if (responseJson?.data) setBrandData(responseJson.data);
          }
        })
        .finally(() => {})
        .catch((error) => {
          console.log(error);
        });
    }
    getBrandData();
  }, []);

  useEffect(() => {
    dispatch(stepsActions.handleStepNumber(stepNumber));
  }, [stepNumber]);

  useEffect(() => {
    if (!products || !products?.length) return;
    handleSelectedCard(product_id);
  }, [product_id, products]);

  async function handleSelectedCard(selectedproduct_id) {
    const selected = products?.find((data) => {
      return data.product_id === selectedproduct_id;
    });
    dispatch(stepsActions.step2(selected));
    handleGenerateCreatives(brandData?.brand_logo);
  }

  if (homePageProfileLoading || isWhatsappLoading) {
    return (
      <div className="puffLoadingSpinner">
        <PuffLoader size={100} color="#0F6EFF" />
      </div>
    );
  }

  return (
    <>
      <Modal style={{ backdropFilter: "blur(10px)" }} open={campaignCreatedModal}>
        <>
          <CampaignCreatedModal />
        </>
      </Modal>
      {(!homePageProfile?.fb_link || homePageProfile?.fb_user_token_valid === false) && <LinkFbPage setIsWhatsAppLinked={setIsWhatsAppLinked} />}
      {!!homePageProfile?.fb_link && !!homePageProfile?.fb_user_token_valid && !isWhatsAppLinked && <CampaignConnectWhatsApp setIsWhatsAppLinked={setIsWhatsAppLinked} />}
      {!!homePageProfile?.fb_link &&
        !!homePageProfile?.fb_user_token_valid &&
        !!isWhatsAppLinked &&
        (showBrandModal ? (
          <Brand setShowBrandModal={setShowBrandModal} isBrandData={isBrandData} />
        ) : (
          <div id="createCampaign">
            <StepsHeadingSection people="1,00,000" stepNumber={stepNumber} />
            <div id={stepNumber === 4 ? "stepsMainContainer" : ""}>
              <StepsContainer
                heading1="Campaign settings"
                heading2="Choose the Product"
                step2="1"
                heading3="Select your ad copy"
                step3="2"
                heading4="Payment"
                step4="3"
                step={stepNumber}
              >
                {stepNumber === 1 && <CampaignStep1 />}
                {stepNumber === 2 && !step2Spinner && <CampaignStep2 products={products} handleSelectedCard={handleSelectedCard} />}
                {stepNumber === 3 && (
                  <CampaignStep3
                    brandData={brandData}
                    creatives={creatives}
                    templates={templates}
                    fetchHeadlines={fetchHeadlines}
                    userData={userData}
                    fetchColors={fetchColors}
                    fetchCaptions={fetchCaptions}
                    scoreImage={scoreImage}
                    setCreatives={setCreatives}
                    setTemplates={setTemplates}
                    isLoading={step3Spinner}
                  />
                )}
                {stepNumber === 4 && !step4Spinner && <CampaignStep4 loading={step4Spinner} pricingData={pricingData} />}
              </StepsContainer>
              {stepNumber === 4 && <Step4BillContainer step4Spinner={step4Spinner} userData={userData} useWallet={useWallet} setUseWallet={setUseWallet} />}
            </div>
            <div className={`${stepNumber > 1 ? "campaign-continue-back-Btn" : "campaign-continue-Btn"}`}>
              {stepNumber > 1 && (
                <button className="step-back-btn step-back-btn-enabled" onClick={handleBackStep}>
                  Back{isStep === "back" && (step2Spinner || step3Spinner || step4Spinner)}
                </button>
              )}
              <button
                className={`step-continue-btn ${stepNumber === 1 && !searchLocationInput ? "step-continue-btn-disabled" : "step-continue-btn-enabled"} ${
                  stepNumber === 2 && !step2Data ? "step-continue-btn-disabled" : "step-continue-btn-enabled"
                } ${stepNumber === 3 && (!step3Data || step3Spinner) ? "step-continue-btn-disabled" : "step-continue-btn-enabled"} ${
                  stepNumber === 4 && !step4Data ? "step-continue-btn-disabled" : "step-continue-btn-enabled"
                } ${isSavingAdcopies ? "step-continue-btn-disabled" : "step-continue-btn-enabled"}`}
                onClick={handleContinue}
                disabled={
                  (stepNumber === 1 && !step2Spinner && !searchLocationInput) ||
                  (stepNumber === 2 && !step3Spinner && !step2Data) ||
                  (stepNumber === 3 && !step4Spinner && !step3Data) ||
                  (stepNumber === 4 && !step4Data) ||
                  isSavingAdcopies
                }
              >
                {stepNumber === 4 ? "Start campaign" : "Continue"}{" "}
                {isStep === "continue" && (step2Spinner || step3Spinner || step4Spinner || isSavingAdcopies) && <PuffLoader size={30} color="#FFF" />}
              </button>
            </div>
          </div>
        ))}
    </>
  );
};

export default CreateCampaign;
